import { createHttpApi, type Api } from "./client";
import { createFixtureApi } from "./fixtures/adapter";
import type { EnvironmentName, RegionToken } from "./schemas";

export const USE_FIXTURES = import.meta.env.VITE_USE_FIXTURES === "1";

/** The single API instance. Control-plane paths are same-origin (`/app`, proxied to :4600 in dev). */
export const api: Api = USE_FIXTURES ? createFixtureApi() : createHttpApi(import.meta.env.VITE_API_BASE ?? "");

// Region tokens live ≤15 min; reuse one until a minute before expiry.
const regionTokens = new Map<string, Promise<RegionToken>>();

export function regionTokenFor(projectId: string, environment: EnvironmentName): Promise<RegionToken> {
  const key = `${projectId}:${environment}`;
  const cached = regionTokens.get(key);
  if (cached) {
    return cached.then((rt) => {
      if (new Date(rt.expires_at).getTime() - Date.now() > 60_000) return rt;
      regionTokens.delete(key);
      return regionTokenFor(projectId, environment);
    });
  }
  const fresh = api.regionToken(projectId, environment);
  regionTokens.set(key, fresh);
  fresh.catch(() => regionTokens.delete(key));
  return fresh;
}

export const clearRegionTokens = () => regionTokens.clear();

export type { Api } from "./client";
export * from "./http";
